import { render, staticRenderFns } from "./M_systemConfig.vue?vue&type=template&id=466386f4&scoped=true&"
import script from "./M_systemConfig.vue?vue&type=script&lang=js&"
export * from "./M_systemConfig.vue?vue&type=script&lang=js&"
import style0 from "./M_systemConfig.vue?vue&type=style&index=0&id=466386f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466386f4",
  null
  
)

export default component.exports